import React from 'react';
import { Modal, TagsInput, Textarea } from '@mantine/core';
import { Button } from '../../../../../components/Button';
import navyModal from '../../../../../components/Modal/navy-modal.module.scss';
import { noSelectionTextInputProps } from '../../receipt/receipt-input.utils';
import { useProductDescriptionController, type ProductDescriptionModalProps } from './useProductDescriptionController';
import classes from './product-description-modal.module.scss';

export const ProductDescriptionModal: React.FC<ProductDescriptionModalProps> = ({
  product,
  products,
  employeeSession,
  onClose,
}) => {
  const { form, setField, isSaving, handleSave, allergenOptions, tagOptions } = useProductDescriptionController({ product, products, employeeSession, onClose });

  return (
    <Modal
      opened
      onClose={onClose}
      title={`תיאור — ${product.name}`}
      centered
      radius="md"
      dir="rtl"
      classNames={{ root: navyModal.root }}
      closeOnClickOutside={false}
      closeButtonProps={{ 'data-testid': 'product-description-close' } as Record<string, string>}
    >
      <div className={classes.fields}>
        <Textarea
          {...noSelectionTextInputProps}
          classNames={{ input: classes.noSelectInput }}
          data-testid="product-description-text"
          label="תיאור"
          value={form.description}
          onChange={(event) => setField('description', event.currentTarget.value)}
          autosize
          minRows={3}
          maxLength={600}
        />
        <TagsInput
          {...noSelectionTextInputProps}
          classNames={{ input: classes.noSelectInput }}
          data-testid="product-description-ingredients"
          label="מרכיבים"
          value={form.ingredients}
          onChange={(value) => setField('ingredients', value)}
          maxTags={30}
          maxLength={40}
        />
        <TagsInput
          {...noSelectionTextInputProps}
          classNames={{ input: classes.noSelectInput }}
          data-testid="product-description-allergens"
          label="אלרגנים"
          data={allergenOptions}
          value={form.allergens}
          onChange={(value) => setField('allergens', value)}
          maxTags={20}
          maxLength={40}
        />
        <TagsInput
          {...noSelectionTextInputProps}
          classNames={{ input: classes.noSelectInput }}
          data-testid="product-description-tags"
          label="תגיות"
          data={tagOptions}
          value={form.tags}
          onChange={(value) => setField('tags', value)}
          maxTags={10}
          maxLength={40}
        />
        <Textarea
          {...noSelectionTextInputProps}
          classNames={{ input: classes.noSelectInput }}
          data-testid="product-description-staff-note"
          label="הערה לצוות"
          value={form.staffNote}
          onChange={(event) => setField('staffNote', event.currentTarget.value)}
          autosize
          minRows={2}
          maxLength={300}
        />
      </div>
      <div className={classes.actions}>
        <Button variant="cancel" onClick={onClose} disabled={isSaving} dataTestId="product-description-cancel">
          ביטול
        </Button>
        <Button
          variant="save"
          onClick={handleSave}
          disabled={isSaving}
          loading={isSaving}
          loadingLabel="שומר..."
          dataTestId="product-description-save"
        >
          שמור
        </Button>
      </div>
    </Modal>
  );
};
